import React from 'react';

const NotFound = () => {
    return (
        <div style={{ textAlign: 'center' }}>
            <h1> 404 not found!</h1>
        </div>
    );
};

export default NotFound;